import React from 'react';

import RichText from '../../shared/components/richtext'

import '../css/product-overview.less';

const ProductOverview = ({ overview }) => {
	return (
		<div className='product-overview'>
			<RichText text={overview} />
		</div>
	);
};

export default ProductOverview;